import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'


export default class extends React.Component {
    static propTypes = {
		thisUserID: PropTypes.number,
		users: PropTypes.array
	};

    getUsernames = () => {

		var users = this.props.users,
			count = users.length;

		if( count == 1 ) {
			if( users[0].ID == this.props.thisUserID ) {
				return 'You'
			} else {
				return <Link to={'/member/' + users[0].ID}>{ users[0].first + ' ' + users[0].last }</Link>
			}
		}

		if( count == 2 ) return <span>
			<Link to={'/member/' + users[1].ID}>{ users[1].first }</Link> and <Link to={'/member/' + users[0].ID}>{ users[0].first }</Link>
		</span>

		if( count == 3 ) return <span>
			<Link to={'/member/' + users[2].ID}>{ users[2].first }</Link>, <Link to={'/member/' + users[1].ID}>{ users[1].first }</Link> and <Link to={'/member/' + users[0].ID}>{ users[0].first }</Link>
		</span>

		if( count >= 4 && count <= 9 ) return <Link to={'/member/' + users[count-1].ID}>{ users[count-1].first + ' and ' + (count - 2) + ' more' }</Link>

		if( count >= 10 ) return <Link to={'/member/' + users[count-1].ID}>{ count + ' people' }</Link>


	};

    render() {

		return (

			<span>{this.getUsernames()}</span>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/components/Usernames.js